import { FC } from 'react';

import type { INewMerchantQuery, INewMerchantResponse } from '@entities/merchant';
import { useCreateMerchantMutation } from '@entities/merchant';
import { ModalNewEntity } from '@features/modal-entity-new';
import { useModal } from '@shared/components/Modal';

import { NewMerchantSettings } from './NewMerchantSettings';

interface IProps {
  refetch: () => void;
}

export const NewMerchantModal: FC<IProps> = ({ refetch }) => {
  const { openModal } = useModal();

  const handleSuccess = (response: INewMerchantResponse) => {
    openModal(
      <NewMerchantSettings
        parent_id={response.data.id}
        parent_name={response.data.short_name}
        refetch={refetch}
      />,
    );
  };

  const transformFormData = (data: FormData) => {
    const values = Object.fromEntries(data.entries());
    return Object.assign(values, { is_test: values.is_test === 'on' });
  };
  const newMerchantKeys: (keyof INewMerchantQuery)[] = ['domain', 'short_name', 'is_test'];

  return (
    <ModalNewEntity
      title='New Merchant'
      submitBtnText='Continue'
      entityKeys={newMerchantKeys}
      useCreateEntityMutation={useCreateMerchantMutation}
      onSuccess={handleSuccess}
      onTransformFormData={transformFormData}
    />
  );
};
